<template>
    <div class="main">
        <ball></ball>
        <div class="nav">
            <van-nav-bar
                    title="检查报告"
                    left-arrow
                    left-text="返回"
                    :fixed='true'
                    @click-left="onClickLeft"
            />
        </div>
        <div class="head">
            <div class="title_head">
                <div class="title_head_name">{{name}}</div>
            </div>
            <div class="head_row">
                <span class="geary">流水号：</span>{{patientId}}
            </div>
        </div>
        <div class="body">
            <div class="listcard" v-if="emptyflag"
                 v-for="(item,index) in pacssampleList "
                 :key="index"
                 @click="reportDetialClick(item)">
                <div class="listcard_title line">
                    <div class="listcard_title_a">状态</div>
                    <div class="listcard_title_b color">可查看</div>
                </div>
                <div class="listcard_row">
                    <div class="listcard_row_a">项目名称</div>
                    <div class="listcard_row_b">{{item.termName}}</div>
                </div>
                <div class="listcard_row">
                    <div class="listcard_row_a">诊断：</div>
                    <div class="listcard_row_b">{{item.diagnose}}</div>
                </div>
                <div class="listcard_row">
                    <div class="listcard_row_a">检查类别：</div>
                    <div class="listcard_row_b" style="color: #f40"> {{item.checkType}}</div>
                </div>
                <div class="listcard_row">
                    <div class="listcard_row_a">检查时间：</div>
                    <div class="listcard_row_b" style="color: #f40"> {{item.checkDate}}</div>
                </div>
            </div>
            <div v-if="!emptyflag">
                <van-empty  image="https://account.kmmds.top/datainfo_pic/error.png" description="暂无报告单" />
            </div>
        </div>
    </div>
</template>

<script>
    import Nav from "@/components/nav.vue";
    import setOptions from "@/mixins/setOption";
    export default {
        name: "hospitalExamineReport",
        mixins: [setOptions],
        data() {
            return {
                pacssampleList:[],
                price:null,
                clientId:"",
                name:"",
                patientId:"暂无",
                emptyflag:true
            };
        },
        components: {
            Nav,
        },
        created() {
            this.clientId = this.$route.query.clientId
            this.name = this.$route.query.name
            this.getpacssample();
        },
        methods: {
            onClickLeft() {
                this.$router.push({
                    path:"/reportList",
                    query:{
                        clientId:this.clientId,
                        name:this.name
                    }
                });
            },
            async getpacssample() {
                // console.log(this.method_depy_type)
                try {
                    let reqData = {
                        clientId:this.clientId //"2020038924",
                    };
                    this.$showLoad();
                    let url = "/report/api/querypacsregisterbyclientid";
                    // console.log(R_data)
                    await this.$axios_request.axios_request_body(
                        "nodeserver",
                        url,
                        "POST",
                        reqData,
                        (data) => {
                            if(data.data.data.data.length === 0){
                                this.emptyflag = false
                            }else{
                                this.pacssampleList=data.data.data.data
                                this.patientId = this.pacssampleList[0].patientId
                            }
                            this.$hideLoad();
                        }
                    );
                } catch (error) {
                    // console.log(error);
                    this.$hideLoad();
                }
            },
            reportDetialClick(item){
                console.log("----->",item);
                this.$router.push({
                    path:"/hospitalExamine_C_detail",
                    query:{
                        clinicId:item.patientId,
                        name:this.name,
                        termName:item.termName
                    }
                })
            }
        },
    };
</script>

<style lang="scss" scoped>
    .color{
        color: #2ed573 !important;
    }

    .main {
        display: flex;
        flex-direction: column;
        max-height: 100vh;
        width: 100%;
        background-color: #eee;
        .nav {
            height: 6vh;
            .top {
                height: 6vh;
            }
        }
        .head {
            width: 100%;
            background-color: #5b8df6;
            height: 15vh;
            display: flex;
            flex-direction: column;
            color: white;
            padding: 15px;
            .title_head {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                line-height: 6vh;
                .title_head_name {
                    font-size: 25px;
                }
                .title_head_age {
                    font-size: 14px;
                }
            }
            .head_row {
                font-size: 14px;
                line-height: 4vh;
                color: #ffffff;
            }
        }
        .body {
            display: flex;
            flex-direction: column;
            width: 100%;
            max-height: 94vh;
            overflow: scroll;
            .listcard {
                display: flex;
                flex-direction: column;
                background-color: white;
                width: 100%;
                margin: 0px auto;
                margin-bottom: 8px;
            }
            .listcard_title {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                line-height: 24px;
                width: 95%;

                padding: 10px;
                margin: 0px auto;
                .listcard_title_a {
                    font-size: 16px;
                }
                .listcard_title_b {
                    font-size: 14px;
                    color: #999;
                }
            }
            .listcard_row {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                line-height: 15px;
                width: 95%;

                padding: 10px;
                margin: 0px auto;
                .listcard_row_a {
                    font-size: 14px;
                    color: #999;
                }
                .listcard_row_b {
                    font-size: 14px;
                }
            }
            .listcard_money {
                line-height: 35px;
                font-size: 14px;
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                width: 95%;
                text-align: end;
                .moneycolor {
                    color: #5b8df6;
                    font-weight: bolder;
                    font-size: 18px;
                }
            }
        }

    }
</style>
